var _mask, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHerdWith10Icon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_534_10279",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 0H0V15H5.32839L7.7251 17.3967L10.1218 15H15V0Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 0H0V15H5.32839L7.7251 17.3967L10.1218 15H15V0Z",
    fill: "#377D21"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0V-0.5H-0.5V0H0ZM15 0H15.5V-0.5H15V0ZM0 15H-0.5V15.5H0V15ZM5.32839 15L5.68195 14.6464L5.5355 14.5H5.32839V15ZM7.7251 17.3967L7.37154 17.7503L7.7251 18.1038L8.07865 17.7503L7.7251 17.3967ZM10.1218 15V14.5H9.91469L9.76825 14.6464L10.1218 15ZM15 15V15.5H15.5V15H15ZM0 0.5H15V-0.5H0V0.5ZM0.5 15V0H-0.5V15H0.5ZM5.32839 14.5H0V15.5H5.32839V14.5ZM8.07865 17.0431L5.68195 14.6464L4.97484 15.3536L7.37154 17.7503L8.07865 17.0431ZM9.76825 14.6464L7.37154 17.0431L8.07865 17.7503L10.4754 15.3536L9.76825 14.6464ZM15 14.5H10.1218V15.5H15V14.5ZM14.5 0V15H15.5V0H14.5Z",
    fill: "black",
    mask: "url(#path-1-inside-1_534_10279)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.553 10V9.524H5.575V6.234H4.763V5.863C4.96833 5.82567 5.14567 5.78133 5.295 5.73C5.449 5.674 5.58667 5.60867 5.708 5.534H6.149V9.524H7.073V10H4.553ZM9.29249 10.084C8.84449 10.084 8.49216 9.88333 8.23549 9.482C7.98349 9.076 7.85749 8.49967 7.85749 7.753C7.85749 7.00167 7.98349 6.43 8.23549 6.038C8.49216 5.646 8.84449 5.45 9.29249 5.45C9.73583 5.45 10.0835 5.646 10.3355 6.038C10.5922 6.43 10.7205 7.00167 10.7205 7.753C10.7205 8.49967 10.5922 9.076 10.3355 9.482C10.0835 9.88333 9.73583 10.084 9.29249 10.084ZM9.29249 9.622C9.55383 9.622 9.76383 9.475 9.92249 9.181C10.0812 8.88233 10.1605 8.40633 10.1605 7.753C10.1605 7.09967 10.0812 6.63067 9.92249 6.346C9.76383 6.05667 9.55383 5.912 9.29249 5.912C9.03116 5.912 8.81883 6.05667 8.65549 6.346C8.49683 6.63067 8.41749 7.09967 8.41749 7.753C8.41749 8.40633 8.49683 8.88233 8.65549 9.181C8.81883 9.475 9.03116 9.622 9.29249 9.622Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHerdWith10Icon);
export default __webpack_public_path__ + "static/media/HerdWith10Icon.5c3b9ef90acbb6c8aeaccd8678b5011b.svg";
export { ForwardRef as ReactComponent };